import { ICommand } from 'core-ts-types';
import { AppointmentSchedulingServant } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { IPopupConfigService } from 'ui-ng-popup';
import { PlatformUtility } from 'utility-ts-platform';
import { UpcomingAppointmentsQuery } from '../../queries/upcoming_appointments_query';
import { IActiveVisit, IAppointment } from '../../types/appointment_interfaces';

export class AppointmentCheckin {
  private appointmentScheduling: any;
  private appointment: IAppointment;
  private canCheckin: boolean;
  private canCheckout: boolean;
  private showCheckInNotAvailable: boolean;
  private isDropin: boolean = false;
  private activeVisit: IActiveVisit;
  private checkoutId: number = -1;
  private attendanceId: number = -1;
  private isMobile: boolean;
  constructor(
    private appConfigModel: any,
    private checkinAppointmentCommand: ICommand,
    private checkoutAppointmentCommand: ICommand,
    private ngPopupService: IPopupConfigService,
    private $state: ng.ui.IStateService,
    private ngUpcomingAppointmentsQuery: UpcomingAppointmentsQuery,
    private log: any,
    private ngAppointmentSchedulingServant: AppointmentSchedulingServant
  ) {}

  $onInit() {
    this.init();
  }

  $onChanges() {
    this.init();
  }

  init() {
    this.isDropin = !_4.isEmpty(this.activeVisit) && _4.isNull(this.activeVisit.attendance_id);
    this.canCheckin = this.isDropin ? false : _4.get(this.appointment, 'can_checkin', false);
    this.canCheckout = this.isDropin
      ? _4.get(this.activeVisit, 'can_checkout', false)
      : _4.get(this.appointment, 'can_checkout') || _4.get(this.appointment, '_canCheckout', false);
    this.checkoutId = this.isDropin
      ? _4.get(this.activeVisit, 'id', -1)
      : _4.get(this.appointment, '_activeVisit.id') || _4.get(this.appointment, 'active_visit_id', -1);
    this.attendanceId = _4.get(this.appointment, 'attendance_id', -1);
    this.showCheckInNotAvailable = !this.canCheckin && !this.canCheckout;
    this.isMobile = PlatformUtility.isMobile();
  }

  postCheckinCheckout() {
    this.redirectUser();
  }

  redirectUser() {
    const currentState = _4.get(this.$state, 'current.name', '');
    if (_4.includes(currentState, 'todos')) {
      return this.$state.go('my.todos');
    }
    return this.$state.go('my.myAppointments.upcoming');
  }

  checkin() {
    this.ngAppointmentSchedulingServant.getSchedulingConfig().then(() => {
      this.checkinAppointmentCommand(this.attendanceId)
        .then((response: any) => {
          const message = `You have checked in to see ${response.data.staff.first_name} ${response.data.staff.last_name}.  Look out for an email, text, or phone call for next steps.`;
          this.ngPopupService.show({
            title: 'Appointment Check-in',
            body: message,
            completeButtonText: 'Okay',
            acceptOnly: true
          });
          this.postCheckinCheckout();
        })
        .catch((error: any) => {
          this.log.error(error);
          this.showErrorModal(error);
        });
    });
  }
  checkout() {
    this.ngAppointmentSchedulingServant.getSchedulingConfig().then(() => {
      this.checkoutAppointmentCommand(this.checkoutId, this.attendanceId)
        .then((response: any) => {
          this.ngPopupService.show({
            title: 'Appointment Checkout',
            body: 'You have successfully been checked out',
            completeButtonText: 'Okay',
            acceptOnly: true
          });
          this.postCheckinCheckout();
        })
        .catch((error: any) => {
          this.log.error(error);
          this.showErrorModal(error);
        });
    });
  }
  showErrorModal(error: any) {
    this.log.error(error);
    this.ngPopupService.show({
      title: 'Appointment Checkout',
      body: _.map(_.get(error, 'data.metadata.errors')).join(' '),
      completeButtonText: 'Okay',
      acceptOnly: true
    });
  }
}

angular
  .module('capability-ng-appointments')
  .component('appointmentCheckin', {
    bindings: {
      appointment: '<',
      activeVisit: '<'
    },
    templateUrl: 'capability-ng-appointments/src/components/appointment_checkin/appointment_checkin.html',
    controller: 'appointmentCheckinController'
  })
  .controller('appointmentCheckinController', AppointmentCheckin);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/appointment_checkin/appointment_checkin.ts